import { render, staticRenderFns } from "./gateway-additional-criteria.vue?vue&type=template&id=09e679bd&"
import script from "./gateway-additional-criteria.vue?vue&type=script&lang=js&"
export * from "./gateway-additional-criteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports